import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/2c21611a-d5e5-4281-8075-cbdd4ec1b924.png" 
              alt="STRADE SRL Logo" 
              className="h-10 w-auto"
            />
            <span className={`text-xl font-bold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              STRADE SRL
            </span>
          </div>

          <div className="flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`font-medium transition-colors hover:text-teal-600 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('vpn')}
              className={`font-medium transition-colors hover:text-teal-600 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              VPN
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className={`font-medium transition-colors hover:text-teal-600 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors hover:text-teal-600 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-colors hover:text-teal-600 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-teal-600 text-white px-6 py-2.5 rounded-full font-medium hover:bg-teal-700 transition-colors flex items-center gap-2 whitespace-nowrap"
            >
              Get Started
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
